import React,{useState,useEffect} from "react";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { makeStyles, withStyles } from "@material-ui/styles";
import Chart from "react-apexcharts";
import * as report from "./summary_report.jsx";


import {
  FinanceService,
  AdminService,
  ReportingService,
  Validator,
  Permissions,
} from "../../utils/web_config";



import {
    Grid,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Chip,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    ListItemSecondaryAction,
    LinearProgress,
    Paper,
    Box,
    IconButton,
    Typography
  } from "@material-ui/core";

  import {
    DesktopMac,
    Add,
    Close,
    FilterList,
    Dashboard as DashboardIcon,
    ArrowDropUp,
    ArrowDropDown,
    FiberManualRecord as Circle,
    ConfirmationNumber,
    AccountBalance,
    Payment,
    Store,
    AcUnit,
    ChevronRight,
    ArrowDropUpOutlined,
    AccountBalanceWallet,
    AllInclusive,
    Money
  } from "@material-ui/icons";


 
import UserInfo from "./login_info";


import {AdminService as Adminservice2,FinanceService as FinanceService2} from "./../../utils/web_config_2";

import { useSnackbar } from 'notistack';


import axios from 'axios';


const useStyles = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        flexFlow:1,
        [theme.breakpoints.up('sm')]:{
          marginLeft:250,
        }
    },
    title: {
      flexGrow: 1,
    },
    btn: {
      textTransform: "lowercase",
    },
    btn2: {
      textTransform: "lowercase",
      border: "dashed grey 1px",
    },
    paper: {
      paddingTop: 10,
      paddingRight: 10,
      paddingLeft: 10,
      paddingBottom: 10,
    
    },
    paper1: {
      paddingTop: 10,
      paddingRight: 10,
      paddingLeft: 10,
      paddingBottom: 10,
      height:120
    
    }
    ,
    action: {
      borderRadius: 15,
    },
  }));

function Dashboard(){
    const classes = useStyles();
    const history = useHistory();

    const onDelete = () => {};
    
    const [agentData,setagentData]=useState({});

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();


  const [transactions, setStransactions] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    saving: false,
    loading: false,
    toggling: false,
    status: "Loading agent transactions",
    agent_transactions:report.transactions,
    data: [],
  });


    useEffect(()=>{
      var data = {};
    const data1 = localStorage.getItem("nx_ag");
    if (data1 != null) {
      data = JSON.parse(data1);
    }

  
    setagentData(data);
    axios.defaults.baseURL = new FinanceService2().BASE_URL;
  
    var dataProfile=JSON.parse(localStorage.getItem('agent_profile'));
  
    get_balance(data.token,dataProfile.code);

    getTransactions(data.token,dataProfile.code)

    },[]);
  
  
  
    // get balance 
    const [currentBalance,setCurrentBalance]=useState("0.0");
    const [closingBalance,setClosingBalance]=useState("0.0");
        // get balance 
        const [openingBalance,setOpeningBalance]=useState("0.0");

    const get_balance=(token,code)=>{
      setCurrentBalance("0.0");
      const balanceInstance = axios.create(new FinanceService2().setHeaders(token));
      balanceInstance.get('/api/v1/getAgentProfile/'+code)
      .then(res=>{
  
        setCurrentBalance(res.data.data.account.current_balance);
        setOpeningBalance(res.data.data.account.opening_balance);
        setClosingBalance(res.data.data.account.closing_balance);
      })
      .catch(err=>{
        if(err.response.status==401){

        }
        enqueueSnackbar(err.message, {
          variant: "error",
          
        });
      });
    }

    ////////////////////////
      ////////////////////

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

      ////////////////////////////////////////////////////////////////////

  const getTransactions = (token, code) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));

    setStransactions({ ...transactions, loading: true });

    usersInstance
      .get(new FinanceService().GET_AGENT_TRANSACTIONS + code + "?per_page=5000")
      .then(function (response) {
        setStransactions({ ...transactions, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setStransactions({
            ...transactions,
            status: "There are no transactions available",
          });
        } else {
          var groups = new Validator().groupArrayOfObjects(
            d.data,
            "tx_type_name"
          );
          var keys = Object.keys(groups);

          var values2 = [];

          keys.map((k, i) => {
            var sum = new Validator().sum(groups[k], "amount");
            values2.push(sum);
          });

      

          const agent_transactions = {
            series: [
              {
                name: "Total amount",
                data: values2,
              },
            ],
            options: {
              chart: {
                type: "bar",
                height: 500,
                toolbar: {
                  show: false,
                  tools: {
                    download: false,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    home: false,
                    reset: false,
                  },
                },
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "55%",
                  endingShape: "rounded",
                },
              },
              xaxis: {
                categories: keys,
              },

            },
          };

          setStransactions({
            ...transactions,
            data: d.data,
            allData: d.data,
            keys: keys,
            groups: groups,
            agent_transactions:agent_transactions
          });
        }
      })
      .catch(function (error) {
        setStransactions({ ...transactions, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setStransactions({ ...transactions, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
   

    return(
        <div className={classes.root}>
     <Box display="flex">
        <Box mr={2}>
          {" "}
          <DashboardIcon color="primary" fontSize="large" />
        </Box>
        <Typography variant="h5" className={classes.title}>
          <b>Dashboard</b>
        </Typography>
      </Box>
      <Box mt={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Paper className={classes.paper1} elevation={0}>
            <Box width={1} display="flex" justifyContent="center">
              <Box flexGrow={1}>
                <Typography color="textSecondary">Opening wallet</Typography>
                <Box mt={1} mb="4px" flexGrow={1}>
                  <Typography variant="h4">{openingBalance} FRW</Typography>
                </Box>
                
              </Box>
              <AccountBalanceWallet color="primary" fontSize="large" />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Paper className={classes.paper1} elevation={0}>
            <Box display="flex" width={1}>
              <Box flexGrow={1}>
                <Typography color="textSecondary">
                  Current Wallet balance
                </Typography>
                <Box mt={1} mb="4px">
    <Typography variant="h4">{currentBalance} FRW</Typography>
                </Box>
                
              </Box>
              <Payment color="primary" fontSize="large" />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Paper className={classes.paper1} elevation={0}>
            <Box display="flex" width={1}>
              <Box flexGrow={1}>
                <Typography color="textSecondary">Closing balancet</Typography>
                <Box mt={1} mb="4px">
                  <Typography variant="h4">{closingBalance} FRW</Typography>
                </Box>
               
              </Box>
              <AllInclusive color="primary" fontSize="large" />
            </Box>
          </Paper>
        </Grid>
        

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Paper className={classes.paper1} elevation={0}>
            <Box display="flex" width={1}>
              <Box flexGrow={1}>
                <Typography color="textSecondary">
                  Total transactions
                </Typography>
                <Box mt={1} mb="4px">
                  <Typography variant="h4">{transactions.data.length}</Typography>
                </Box>
              </Box>
              <Money color="primary" fontSize="large" />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className={classes.paper} elevation={0}>
              <Box display="flex">
                  <Typography color="textSecondary">Daily Transactions</Typography>
              </Box>
              <Box mt={1}>
              <Chart options={transactions.agent_transactions.options} series={transactions.agent_transactions.series} type="bar" width={"100%"} height={500} />
        
              </Box>
          </Paper>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={4} lg={4}>
            <Box>
            <Paper className={classes.paper} elevation={0}>
              <Box display="flex">
                  <Typography color="textSecondary">Card Stock</Typography>
              </Box>
              <Box mt={1}>
              <Chart options={report.stock.options} series={report.stock.series} type="bar" width={"100%"} height={350} />
        
              </Box>
          </Paper>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={8} lg={8}>
          <Paper className={classes.paper} elevation={0}>
              <Box display="flex">
              <Typography color="textSecondary">Assistant daily performance</Typography>
              </Box>
              <Box mt={1}>
              <Chart options={report.assistant_performance.options} series={report.assistant_performance.series} type="bar" width={"100%"} height={350} />
              </Box>
          </Paper>
          </Grid> */}

        
        </Grid>
      </Box>

        </div>
    ); 
}

export default withLocalize(Dashboard);